export default __webpack_public_path__ + "static/media/esif.5864da48.png";